import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { of, Observable, switchMap } from 'rxjs';
import { navigateToHome } from '../../../../../core/resolver/shared/functions/navigate-to-home.function';
import { ApplicationService } from '../../../shared/services/application/application.service';

export const GoPageApplicationStateRefreshResolver = (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    route: ActivatedRouteSnapshot,
): Observable<boolean> => {
    const applicationService = inject(ApplicationService);

    const router = inject(Router);

    const applicationId = route.paramMap.get('id');

    if (!applicationId) {
        return navigateToHome(router);
    }

    return applicationService.getApplicationState(applicationId).pipe(
        switchMap((state) => {
            if (!state) {
                return navigateToHome(router);
            }

            return of(true);
        }),
    );
};
